import { forwardRef, useImperativeHandle } from "react";
import { QuestionStyle, Question, Answer, QuestionContainer } from "./QuestionslStyled.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";

interface Props {
  questionsArray: Array<{ question: string; answer: string }>;
}

const Questions = forwardRef(({ questionsArray }: Props, Ref) => {
  useImperativeHandle(Ref, () => ({}));

  return (
    <QuestionStyle>
      {questionsArray.map((question: { question: string; answer: string }) => (
        <QuestionContainer>
          <Question>{question.question}</Question>
          <Answer><FontAwesomeIcon icon={faArrowAltCircleRight} /> {question.answer}</Answer>
        </QuestionContainer>
      ))}
    </QuestionStyle>
  );
});

export default Questions;
